window.addEventListener("DOMContentLoaded", () => {
  // reviews 星级小模块点击后页面滑动到 reviews 板块
  const tabBarEl = document.querySelector(".product-tabs-description__tab-bar");
  const headerEl = document.querySelector(".section-header");
  document.querySelector("product-info .stamped-product-reviews-badge")?.addEventListener("click", (e) => {
      const $el = $(e.currentTarget);
      $el.children(".review").attr("disabled", true).css("pointer-events", "none");
      $(`.product-tabs-description__tab-bar li[data-handle="reviews"]`).click();
      if (tabBarEl) {
        $("html,body").animate({ scrollTop: tabBarEl.offsetTop - headerEl.clientHeight + "px" },300);
      }
      e.stopPropagation();
  });


  const DOM_CACHE = {
    header: document.querySelector("sticky-header"),
    navContainer: document.querySelector(".product-tabs-description__tab-bar"),
    targetHideElement: document.querySelector(".product__info-wrapper"),
  };

  // 2. 计算导航高度
  function updateHeaderHeights() {
    const { header } = DOM_CACHE;
    if (!(header instanceof HTMLElement)) return;
    const headerHeight = header.offsetHeight;
    document.body.style.setProperty("--header-height", `${headerHeight}px`);
  }

  function handleScroll() {
    const { navContainer, targetHideElement } = DOM_CACHE;

    if (!targetHideElement) return;

    const targetHideRect = targetHideElement.getBoundingClientRect();
    const isTargetOutOfView = targetHideRect.bottom <= 10;

    // 任务栏悬浮逻辑
    if (navContainer) {
      if (isTargetOutOfView) {
        navContainer.classList.add("active");
        updateHeaderHeights();
      } else {
        navContainer.classList.remove("active");
      }
    }


    // 价格悬浮板块逻辑
    const priceContainer = document.querySelector(".price-suspend")

    if (priceContainer) {
      if (isTargetOutOfView) {
        priceContainer.classList.add("active");
      } else {
        priceContainer.classList.remove("active");
      }
    }
  }

  // 防抖处理
  function debounce(func, delay = 30) {
    let timer = null;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  }

  const debouncedHandleScroll = debounce(handleScroll);

  function init() {
    updateHeaderHeights();
    window.addEventListener("scroll", debouncedHandleScroll);
    handleScroll();
  }

  init();
});
